<template>
  <transition name="slide-fade">
    <v-card :color="variant" dark max-width="350" hover @click="goToEvent">
      <v-card-title>
        <img
          v-if="newEvents.eventImportance == 'Critical' && newEvents.eventCategory == 'Plc'"
          src="./side-drawer/side-drawer-assets/PoliceCritical.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Critical' && newEvents.eventCategory == 'Hlt'"
          src="./side-drawer/side-drawer-assets/HealthCritical.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Critical' && newEvents.eventCategory == 'ND'"
          src="./side-drawer/side-drawer-assets/NaturalDisasterCritical.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Warning' && newEvents.eventCategory == 'Plc'"
          src="./side-drawer/side-drawer-assets/PoliceWarning.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Warning' && newEvents.eventCategory == 'Hlt'"
          src="./side-drawer/side-drawer-assets/HealthWarning.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Warning' && newEvents.eventCategory == 'ND'"
          src="./side-drawer/side-drawer-assets/NaturalDisasterWarning.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Information' && newEvents.eventCategory == 'Plc'"
          src="./side-drawer/side-drawer-assets/PoliceInformation.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Information' && newEvents.eventCategory == 'Hlt'"
          src="./side-drawer/side-drawer-assets/HealthInformation.svg"
        />
        <img
          v-if="newEvents.eventImportance == 'Information' && newEvents.eventCategory == 'ND'"
          src="./side-drawer/side-drawer-assets/NaturalDisasterInformation.svg"
        />
        <span class="title pl-3 font-weight-bold">{{ newEvents.eventImportance }}</span>
      </v-card-title>

      <v-card-text> {{ newEvents.eventTitle }} </v-card-text>

      <v-card-actions>
        <v-list-tile class="grow">
          <v-list-tile-content>
            <v-list-tile-title class="publishTime">{{ timeFromNow }}</v-list-tile-title>
          </v-list-tile-content>
          <v-layout align-center justify-end>
            <v-icon class="mr-1">mdi-chart-line</v-icon>
            <span class="subheading mr-2">{{ newEvents.eventMeter }}</span> <span class="mr-1">·</span>
            <v-icon class="mr-1">mdi-google-nearby</v-icon>
            <span class="subheading">{{ newEvents.eventMagnitude }}</span>
          </v-layout>
        </v-list-tile>
      </v-card-actions>
    </v-card>
  </transition>
</template>

<script>
export default {
  name: 'NewEvents',
  props: {
    newEvents: {
      type: Object,
      required: true
    },
    getDate: {
      type: Number
    }
  },
  computed: {
    variant() {
      switch (this.newEvents.eventImportance) {
        case 'Warning':
          return 'warning';
        case 'Critical':
          return 'critical';
      }
      return 'info';
    },
    timeFromNow() {
      let difference = (this.getDate - this.newEvents.eventPublishTime) / 1000 / 60;
      return `${Math.floor(difference)} Minutes ago`;
    }
  },
  methods: {
    goToEvent() {
      this.$emit('updateInternalIndex', 0);
      this.$store.dispatch('select', 0);
    }
  }
};
</script>

<style scoped>
.publishTime {
  font-size: 0.9rem !important;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
